<app-loading-state *ngIf="loading" [compact]="true" message="Cargando movimientos de la caja…"></app-loading-state>

<div class="cd-empty cd-empty--error" *ngIf="!loading && error">
  <mat-icon>error</mat-icon>
  <span>No se pudieron cargar los movimientos de la caja.</span>
  <button mat-stroked-button class="cf-btn" (click)="retry()">
    <mat-icon>refresh</mat-icon> Reintentar
  </button>
</div>

<div class="cd-panel" *ngIf="!loading && !error">
  <section class="cd-card">
    <div class="cd-card__header">
      <span class="cd-card__title"><mat-icon>account_balance_wallet</mat-icon> Resumen de la caja</span>
      <span class="cd-card__hint" *ngIf="row.ubicacion">{{ row.ubicacion }}</span>
    </div>

    <div class="cd-kpis">
      <div class="cd-kpi cd-kpi--accent">
        <span class="cd-kpi__label">Saldo contable {{ year }}</span>
        <span class="cd-kpi__value" [class.cd-kpi__value--negative]="row.saldoContable < 0">{{ (row.saldoContable || 0) | number:'1.2-2' }} €</span>
      </div>
      <div class="cd-kpi">
        <span class="cd-kpi__label">Fondo de caja</span>
        <span class="cd-kpi__value">{{ (row.fondoDeCaja || 0) | number:'1.2-2' }} €</span>
      </div>
      <div class="cd-kpi">
        <span class="cd-kpi__label">Movimientos {{ year }}</span>
        <span class="cd-kpi__value">{{ movementsCount }}</span>
      </div>
    </div>

    <div class="cd-lines">
      <div class="cd-line" *ngFor="let block of blocks; trackBy: trackByKind">
        <span class="cd-line__label"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
        <span class="cd-line__value">{{ block.total | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="cd-card__actions" *ngIf="row.accountingModelsNumber">
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="ledger.emit()">
        <mat-icon>title</mat-icon> Mayor contable {{ row.accountingModelsNumber }}
      </button>
    </div>
  </section>

  <section class="cd-card">
    <div class="cd-card__header">
      <span class="cd-card__title"><mat-icon>swap_horiz</mat-icon> Movimientos de {{ year }}</span>
    </div>

    <div class="cd-block" *ngFor="let block of blocks; trackBy: trackByKind">
      <div class="cd-block__header">
        <span class="cd-block__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
        <span class="cd-block__side">
          <span class="cd-block__meta" *ngIf="block.count">{{ block.count }} · <strong>{{ block.total | number:'1.2-2' }} €</strong></span>
          <button mat-stroked-button type="button" class="cf-btn cf-btn--primary cd-add" (click)="add(block)">
            <mat-icon>add</mat-icon> Añadir
          </button>
        </span>
      </div>

      <div class="cd-rows" *ngIf="block.lines.length">
        <div class="cd-row" *ngFor="let line of block.lines; trackBy: trackByUid">
          <span class="cd-row__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
          <span class="cd-row__main">
            <span class="cd-row__concept" [title]="line.concept">{{ line.concept || 'Sin concepto' }}</span>
            <span class="cd-row__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
          </span>
          <span class="cd-row__amount">{{ line.amount | number:'1.2-2' }} €</span>
          <span class="cd-row__actions">
            <button type="button" class="cd-icon-btn" (click)="editLine(block, line)" title="Editar" aria-label="Editar movimiento">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" class="cd-icon-btn cd-icon-btn--danger" (click)="deleteLine(block, line)" title="Eliminar" aria-label="Eliminar movimiento">
              <mat-icon>delete</mat-icon>
            </button>
          </span>
        </div>
        <button type="button" class="cd-more" *ngIf="block.count > maxLines" (click)="manage(block)">
          Ver los {{ block.count }} movimientos <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="cd-block__empty" *ngIf="!block.lines.length">Sin movimientos en {{ year }}</div>
    </div>
  </section>
</div>
